import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Checkbox } from "@material-ui/core";
import { AiOutlineDownload } from "react-icons/ai";
import { IoCloudDone } from "react-icons/io5";
import { MdOutlineDelete, MdMessage, MdArrowForward } from "react-icons/md";
import { BsCloudArrowUp } from "react-icons/bs";
import { addUserService, assignRoleService } from "../../services/api-service";
// import "../../assets/css/add-user/premium-form.css";

import "./add-user.css"

let user = {
  name: "",
  email: "",
  password: "",
  mobile_no: "",
  company: "",
  is_admin: false,
};

const AddUser = (props) => {
  const history = useHistory();
  let modify = false;

  try {
    if (history.location.state?.user) {
      user = history.location.state.user;
    }
    if (history.location.state?.modify) {
      modify = history.location.state.modify;
    }
    user = {
      name: user.name || "",
      email: user.email || "",
      password: user.password || "",
      mobile_no: user.mobile_no || "",
      company: user.company || "",
      is_admin: user.is_admin || false,
    };
  } catch (error) {
    user = {
      name: "",
      email: "",
      password: "",
      mobile_no: "",
      company: "",
      is_admin: false,
    };
  }

  // Form states
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [password, setPassword] = useState(user.password);
  const [mobile_no, setMobile] = useState(user.mobile_no);
  const [company, setCompany] = useState(user.company);
  const [is_admin, setIsAdmin] = useState(user.is_admin);
  const [base64Image, setBase64Image] = useState(user.image);

  // Image states
  const [image, setImage] = useState({ bytes: "", file: "/noimage.jpg" });
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isImageSelected, setIsImageSelected] = useState(false);

  // Role states
  const [showRoleForm, setShowRoleForm] = useState(false);
  const [userIdForRole, setUserIdForRole] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [roleForm, setRoleForm] = useState({
    role_type: "CLASS_TEACHER",
    room_number: "",
    location: "",
    hostel_name: "",
    boarding_type_filter: "",
  });

  // Image handlers
  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const objectUrl = URL.createObjectURL(file);
    const reader = new FileReader();

    reader.onload = () => {
      const base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      setImage({
        bytes: file,
        file: objectUrl,
        base64: base64String,
      });
      setIsImageSelected(true);
    };

    reader.readAsDataURL(file);
  };

  const handleSaveImage = () => {
    if (image?.base64) {
      setIsImageUploading(false);
      toast.success("Profile picture updated successfully");
    }
  };

  const handleDiscardImage = () => {
    setImage({ bytes: "", file: "/noimage.jpg" });
    setIsImageSelected(false);
    setIsImageUploading(false);
  };

  // Add user
  const addUserHandler = async (event) => {
    event.preventDefault();

    if (!name.trim()) {
      toast.warn("Please enter full name");
      return;
    }
    if (!email.trim()) {
      toast.warn("Please enter email address");
      return;
    }
    if (!password.trim() && !modify) {
      toast.warn("Please enter password");
      return;
    }

    const finalImage = image?.base64 || base64Image || "";

    const data = {
      name: name.trim(),
      email: email.trim(),
      password: password.trim(),
      mobile_no: mobile_no.trim(),
      company: company.trim(),
      image: finalImage,
      is_owner: false,
      is_admin: is_admin,
    };

    try {
      setIsSubmitting(true);
      const response = await addUserService(data);

      if (response?.status === 201 || response?.status === 200) {
        toast.success(
          modify ? "User profile updated successfully" : "New user created successfully"
        );

        const newUserId = response.data.id || response.data.user_id;

        if (newUserId && !modify) {
          setUserIdForRole(newUserId);
          setShowRoleForm(true);
        } else {
          history.replace("/", {});
        }
      } else {
        toast.error("Failed to create user");
      }
    } catch (error) {
      toast.error("Error creating user. Please try again.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Assign role
  const assignRoleHandler = async (event) => {
    event.preventDefault();

    if (!roleForm.role_type) {
      toast.warn("Please select a role");
      return;
    }

    if (roleForm.role_type === "CLASS_TEACHER" && !roleForm.room_number) {
      toast.warn("Please enter classroom number");
      return;
    }

    if (roleForm.role_type === "HOSTEL_WARDEN" && !roleForm.hostel_name) {
      toast.warn("Please enter hostel name");
      return;
    }

    if (!roleForm.location) {
      toast.warn("Please enter location");
      return;
    }

    const roleData = {
      user_id: userIdForRole,
      role_type: roleForm.role_type,
      room_number:
        roleForm.role_type === "CLASS_TEACHER" ? roleForm.room_number : null,
      location: roleForm.location,
      hostel_name:
        roleForm.role_type === "HOSTEL_WARDEN" ? roleForm.hostel_name : null,
      boarding_type_filter: roleForm.boarding_type_filter || null,
    };

    try {
      setIsSubmitting(true);
      const response = await assignRoleService(roleData);

      if (response?.status === 200 || response?.status === 201) {
        toast.success("Role assigned successfully");
        history.replace("/", {});
      } else {
        toast.error("Failed to assign role");
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to assign role");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Image upload modal
  if (isImageUploading) {
    return (
      <div className="modern-form-container">
        <div className="form-wrapper image-modal">
          <div className="form-header">
            <h2 className="form-title">Upload Profile Picture</h2>
            <p className="form-subtitle">Add a professional profile photo (PNG or JPG)</p>
          </div>

          {!isImageSelected ? (
            <div className="image-upload-area">
              <div className="upload-icon">
                <BsCloudArrowUp size={52} />
              </div>
              <h3>Drag and drop your image</h3>
              <p className="upload-text">or click below to browse</p>
              <input
                onChange={handleImageUpload}
                type="file"
                id="image-input"
                hidden
                accept="image/png,image/jpeg"
              />
              <label htmlFor="image-input" className="btn-browse">
                <AiOutlineDownload size={18} />
                Browse Files
              </label>
            </div>
          ) : (
            <div className="image-preview-large">
              <img src={image.file} alt="Upload preview" />
            </div>
          )}

          <div className="modal-actions">
            <button
              type="button"
              onClick={handleSaveImage}
              disabled={!isImageSelected}
              className="btn-primary"
            >
              <IoCloudDone size={20} />
              Save Picture
            </button>
            <button
              type="button"
              onClick={handleDiscardImage}
              className="btn-secondary"
            >
              <MdOutlineDelete size={20} />
              Discard
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Role assignment form
  if (showRoleForm) {
    return (
      <div className="modern-form-container">
        <div className="form-wrapper">
          <div className="form-header">
            <h1 className="form-title">Assign User Role</h1>
            <p className="form-subtitle">Configure the user's role and responsibilities in the system</p>
          </div>

          <form onSubmit={assignRoleHandler} className="modern-form">
            <div className="form-section">
              <h3 className="section-title">Role Configuration</h3>
              <div className="form-grid">
                <div className="form-group full-width">
                  <label htmlFor="role_type" data-required="*">Role Type</label>
                  <select
                    id="role_type"
                    value={roleForm.role_type}
                    onChange={(e) =>
                      setRoleForm({ ...roleForm, role_type: e.target.value })
                    }
                    className="form-input"
                  >
                    <option value="CLASS_TEACHER">Class Teacher</option>
                    <option value="HOSTEL_WARDEN">Hostel Warden</option>
                    <option value="LAB_INCHARGE">Lab In-Charge</option>
                  </select>
                </div>

                <div className="form-group full-width">
                  <label htmlFor="location" data-required="*">Location / Building</label>
                  <input
                    id="location"
                    type="text"
                    value={roleForm.location}
                    onChange={(e) =>
                      setRoleForm({ ...roleForm, location: e.target.value })
                    }
                    placeholder="e.g., Main Building, Science Wing"
                    className="form-input"
                  />
                </div>

                {roleForm.role_type === "CLASS_TEACHER" && (
                  <div className="form-group full-width">
                    <label htmlFor="room_number" data-required="*">Classroom Number</label>
                    <input
                      id="room_number"
                      type="text"
                      value={roleForm.room_number}
                      onChange={(e) =>
                        setRoleForm({ ...roleForm, room_number: e.target.value })
                      }
                      placeholder="e.g., 101, Grade 10-A"
                      className="form-input"
                    />
                  </div>
                )}

                {roleForm.role_type === "HOSTEL_WARDEN" && (
                  <>
                    <div className="form-group full-width">
                      <label htmlFor="hostel_name" data-required="*">Hostel Name</label>
                      <input
                        id="hostel_name"
                        type="text"
                        value={roleForm.hostel_name}
                        onChange={(e) =>
                          setRoleForm({ ...roleForm, hostel_name: e.target.value })
                        }
                        placeholder="e.g., Boys Hostel, East Wing"
                        className="form-input"
                      />
                    </div>

                    <div className="form-group full-width">
                      <label htmlFor="boarding_type">Visibility Filter</label>
                      <select
                        id="boarding_type"
                        value={roleForm.boarding_type_filter}
                        onChange={(e) =>
                          setRoleForm({
                            ...roleForm,
                            boarding_type_filter: e.target.value,
                          })
                        }
                        className="form-input"
                      >
                        <option value="">All Hostel Students</option>
                        <option value="hostel">Hostel Only</option>
                      </select>
                      <small className="help-text">
                        Define which student records are visible to this warden
                      </small>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" disabled={isSubmitting} className="btn-primary">
                <MdArrowForward size={20} />
                {isSubmitting ? "Assigning Role..." : "Assign Role"}
              </button>
              <button
                type="button"
                onClick={() => setShowRoleForm(false)}
                className="btn-secondary"
              >
                Continue Later
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  // Main user creation form
  return (
    <div className="modern-form-container">
      <div className="form-wrapper">
        <div className="form-header">
          <h1 className="form-title">
            {modify ? "Update User Profile" : "Create New User"}
          </h1>
          <p className="form-subtitle">
            {modify
              ? "Modify user information and account details"
              : "Add a new user to the system with complete information"}
          </p>
        </div>
<div style={{ display : "flex" , alignItems : "center" , justifyContent :"center"}}>

        <form onSubmit={addUserHandler} className="modern-form">
          {/* Basic Information Section */}
          <div className="form-section">
            <h3 className="section-title">Account Information</h3>
            <div className="form-grid">
              <div className="form-group">
                <label style={{ border : "none"  ,
                      paddingLeft: "35px",
    marginBottom: "-10px"
                }} htmlFor="name"data-required="*">Full Name</label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="John Doe"
                  autoComplete="off"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label style={{ border : "none" , paddingLeft: "35px",
    marginBottom: "-10px"}} htmlFor="email" data-required="*">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="john.doe@school.edu"
                  disabled={modify}
                  autoComplete="off"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label style={{ border : "none" , paddingLeft: "35px",
    marginBottom: "-10px"}} htmlFor="password" data-required={!modify ? "*" : ""}>
                  Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={modify ? "Leave blank to keep existing password" : "Enter strong password"}
                  autoComplete="off"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label style={{ border : "none" ,  paddingLeft: "35px",
    marginBottom: "-10px"}} htmlFor="mobile">Mobile Number</label>
                <input
                  id="mobile"
                  type="tel"
                  value={mobile_no}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder="+91 98765 43210"
                  autoComplete="off"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label style={{ border : "none" ,  paddingLeft: "35px",
    marginBottom: "-10px"}} htmlFor="department">Department / Faculty</label>
                <input
                  id="department"
                  type="text"
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                  placeholder="e.g., Science, Mathematics"
                  autoComplete="off"
                  className="form-input"
                />
              </div>

              <div className="form-group checkbox-group">
                <label className="checkbox-label" style={{ paddingLeft : "12px" , border : "none" ,  paddingLeft: "35px",
    marginBottom: "-10px"}}>
                  <Checkbox
                    id="is_admin"
                    checked={is_admin}
                    onChange={(e) => setIsAdmin(e.target.checked)}
                    className="checkbox-input"
                  />
                  <span>Administrator Privileges</span>
                </label>
              </div>
            </div>
          </div>

          {/* Profile Picture Section */}
          {/* <div className="form-section">
            <h3 className="section-title">Profile Picture</h3>
            <div className="image-section">
              {isImageSelected ? (
                <div className="image-preview">
                  <img src={image.file} alt="Profile preview" className="preview-image" />
                  <p className="image-status">Image Selected</p>
                </div>
              ) : base64Image ? (
                <div className="image-preview">
                  <img
                    src={`data:image/*;base64,${base64Image}`}
                    alt="Current profile"
                    className="preview-image"
                  />
                  <p className="image-status">Current Picture</p>
                </div>
              ) : (
                <div className="no-image">
                  <span className="no-image-icon">👤</span>
                  <p>No profile picture</p>
                </div>
              )}
              <button
                type="button"
                onClick={() => setIsImageUploading(true)}
                className="btn-image-upload"
              >
                <AiOutlineDownload size={16} />
                Upload Picture
              </button>
            </div>
          </div> */}

          {/* Form Actions */}
          <div className="form-actions">
            <button type="submit" disabled={isSubmitting} className="btn-primary">
              <MdMessage size={20} />
              {isSubmitting ? "Processing..." : modify ? "Update Profile" : "Create Account"}
            </button>
          </div>
        </form>

</div>
      </div>
    </div>
  );
};

export default AddUser;